import React from "react";

const WishlistToggle = ({isInWishlist, onChange}) => {
  const classNames = ["pdp-hero__wishlist-cta"];
  const toggleText = isInWishlist ? "Added to Wishlist" : "Add to Wishlist";

  if (isInWishlist) { classNames.push("pdp-hero__wishlist-cta--added"); }

  return (
    <button
      id="pdp-wishlist"
      className={classNames.join(" ")}
      onClick={onChange}
    >
      <span className="pdp-hero__cw-icon pdp-hero__cw-icon--wishlist"></span>
      <span className="pdp-hero__wishlist-text">{toggleText}</span>
    </button>
  );
};

export default WishlistToggle;